export default __webpack_public_path__ + "static/media/ic_substack.dcefd627.svg";